module.exports = __webpack_public_path__ + "media/images/emblems/Neyruz-coat_of_arms-b40c11d7f989ddba089cc8a56ae9fc3e.svg";